import { render, staticRenderFns } from "./SubjectsBar.vue?vue&type=template&id=162869e6&"
import script from "./SubjectsBar.vue?vue&type=script&lang=ts&"
export * from "./SubjectsBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports